import { OpaccDateRangePicker } from "../../lib/daterangepicker/opacc.lib.daterangepicker.js";
import {default as OpaccDateRangeL10n} from '../../lib/daterangepicker/l10n/index.js';

/** @module filter */

/**
 * Funktionalität des Filter-Typ "DatePicker".
 */
export class DatePickerFilter {
	constructor(item,wrapper,opaccFilterCriterias) {
		this.wrapperItem = wrapper;
		this.filterItem = item;
		this.opaccFilterCriterias = opaccFilterCriterias;
        this.datePickerFilterType = undefined;
        this.datePickerSelectType = undefined;
		this.dateRangeFilter = undefined;
		this.datePickerValues = undefined;
        this.datePickerInputFrom = undefined;
        this.datePickerInputTo = undefined;
		this.datePickerElem = undefined;
        this.datePickerBtn = undefined;

		this.defaultDate = [];
		this.itemId = undefined;
        this.locale = 'de-CH';
        this.dateStartIndex = 0;
        this.dateEndIndex= 10;

		if (this.filterItem) {
			this.itemId = `#${this.filterItem.getAttribute('id')}`;
			this.datePickerElem = this.filterItem.querySelector(`${this.itemId}-date`);
            this.datePickerInputFrom = this.filterItem.querySelector(`${this.itemId}-from`);
            this.datePickerInputTo = this.filterItem.querySelector(`${this.itemId}-to`);
            this.datePickerFilterType = this.filterItem.dataset.opFiltertype;
            this.datePickerSelectType = this.filterItem.dataset.opSelecttype ? this.filterItem.dataset.opSelecttype : 'range';

			this.datePickerValues = [
				this.datePickerInputFrom,
				this.datePickerInputTo
			];

			this.datePickerValues.forEach(item => {
				this.defaultDate.push(item.value);
			});

			const minDate = this.filterItem.querySelector(`${this.itemId}-from`).getAttribute('data-op-min');
			const maxDate = this.filterItem.querySelector(`${this.itemId}-to`).getAttribute('data-op-max');

			let dateRangePickerConfig = {
				mode: this.datePickerSelectType,
				dateFormat: 'd.m.Y',
                locale: this.getLocale(1),
				inline: true,
				appendTo: this.datePickerElem.parentNode,
				defaultDate: null,
				minDate: minDate,
				maxDate: maxDate
			};


			// prüfen ob Attribut schon selektiert wurde um den Kalender die Selektierten Werte als Default zu übergeben
			if (this.datePickerElem.dataset.opHasSelectedItems) {
				let hasSelectedItems = (this.datePickerElem.dataset.opHasSelectedItems.toLowerCase() === 'true');
				if (hasSelectedItems) {
					dateRangePickerConfig.defaultDate = this.defaultDate;
				}
			}

            this.datePickerBtn = this.filterItem.querySelector(`${this.itemId}-apply-btn`);
			this.createDatePicker(dateRangePickerConfig);
		}
	}

	/**
	 *
	 *
	 * @param {*} config
	 */
	createDatePicker(config) {
		this.dateRangeFilter = new OpaccDateRangePicker(this.filterItem, config);
		this.updateDatePicker(config);
        this.attachInputEvents(config);
	}

	/**
	 *
	 *
	 */
	updateDatePicker(config) {
        if (this.datePickerBtn) {
            let updateFilterCriteria = () => {
                this.checkValuesOnEvent(config);
                this.updateDatePickerOnInput();
            };

            let updateOnKeyEvent = event => {
                if (event.keyCode === 13) {
                    updateFilterCriteria();
                }
            };

            this.datePickerBtn.onclick = updateFilterCriteria;
            this.datePickerInputFrom.onkeyup = updateOnKeyEvent;
            this.datePickerInputTo.onkeyup = updateOnKeyEvent;
        }

        // eslint-disable-next-line no-unused-vars
        this.dateRangeFilter.config.onChange.push( (selectedDates, dateStr, instance) => {
            this.datePickerElem.value = dateStr;
            if (selectedDates.length == 2) {
                this.extractValues(selectedDates);
            }

            if (this.datePickerSelectType == 'single' && selectedDates.length == 1) {
                if (this.datePickerFilterType == 'E') {
                    selectedDates.unshift(null);
                }

                this.extractValues(selectedDates);
            }
        });
	}

    /**
     *
     *
     * @param {*} config
     */
    attachInputEvents(config) {
        let inputBlurEvent = event => {
            let minDate = new Date(this.getISODate(config.minDate));
            let maxDate = new Date(this.getISODate(config.maxDate));
            let valueDate = new Date(this.getISODate(event.target.value));

            if (event.target.id === this.datePickerInputFrom.id && (isNaN(valueDate) || valueDate < minDate)) {
                event.target.value = config.minDate.substring(this.dateStartIndex,this.dateEndIndex);
            }

            if (event.target.id === this.datePickerInputTo.id && (isNaN(valueDate) || valueDate > maxDate)) {
                event.target.value =  config.maxDate.substring(this.dateStartIndex,this.dateEndIndex);
            }
        };

        this.datePickerInputFrom.onblur = inputBlurEvent;
        this.datePickerInputTo.onblur = inputBlurEvent;
    }

    /**
     *
     *
     * @param {*} config
     */
    checkValuesOnEvent(config) {
        let minDate = new Date(this.getISODate(config.minDate)); //date is wrong input has to be iso date
        let maxDate = new Date(this.getISODate(config.maxDate));
        let fromDate = new Date(this.getISODate(this.datePickerInputFrom.value));
        let toDate = new Date(this.getISODate(this.datePickerInputTo.value));

        if (isNaN(fromDate) || fromDate < minDate) {
            this.datePickerInputFrom.value = config.minDate.substring(this.dateStartIndex,this.dateEndIndex);
        }

        if (isNaN(toDate) || toDate > maxDate) {
            this.datePickerInputTo.value =  config.maxDate.substring(this.dateStartIndex,this.dateEndIndex);
        }
    }

    /**
     *
     *
     */
    updateDatePickerOnInput() {
        this.dateRangeFilter.clear();
        this.dateRangeFilter.setDate([this.datePickerInputFrom.value, this.datePickerInputTo.value]);
        this.extractValues(this.dateRangeFilter.selectedDates);
    }

	/**
	 *
	 *
	 * @param {*} inputDates
	 */
	extractValues(inputDates) {
		this.datePickerValues.forEach((item, index) => {
			if (!inputDates[index])
			{
				inputDates[index] = null;
				item.value = null;
				return;
			}

			item.value = inputDates[index].toLocaleDateString(this.locale, this.getDateOptions());
		});

		let formattedDates = [];
		inputDates.forEach(item => {
			formattedDates.push(this.formatInputDate(item));
		});

		let valueConcat = `[${formattedDates.join('|')}]`;
		if (valueConcat == '[|]')
		{
			formattedDates[0] = this.formatInputDate(new Date("0001-01-01"));
			formattedDates[1] = new Date(9999, 11, 31).toLocaleDateString(this.locale, this.getDateOptions());
			valueConcat = `[${formattedDates.join('|')}]`;
		}

		this.opaccFilterCriterias.change(this.datePickerElem.dataset.opFilterattr, valueConcat, true, this.datePickerElem.closest('.opc-filter').dataset.opGroupid, this.datePickerElem.closest('.opc-filter').id);
	}

	/**
	 *
	 *
	 * @param {*} date
	 */
	formatInputDate(date) {
		if (!date)
		{
			return null;
		}

		return [
		  this.padToDigits(date.getDate(), 2),
		  this.padToDigits(date.getMonth() + 1, 2),
		  this.padToDigits(date.getFullYear(), 4),
		].join('.');
	}

	/**
	 *
	 *
	 * @param {*} number
	 * @param {*} length
	 */
	padToDigits(number, length) {
		if (length === void 0) { length = 2; }
		return ("000" + number).slice(length * -1);
	};

	/**
	 *
	 *
	 */
	getDateOptions() {
		return { year: 'numeric', month: '2-digit', day: '2-digit' };
	};

	/**
	 *
	 *
	 * @param {*} lang
	 * @returns {*}
	 */
	getLocale(lang) {
		let locale = null;
        let filename = null;

		switch (+lang) {
		case 1:
			locale = 'de';
			break;
        case 2:
            locale = 'fr';
			break;
        case 3:
            locale = 'it';
			break;
		default:
			locale = 'en';
			break;
		}

        return OpaccDateRangeL10n[locale];
	}

    /**
     *
     *
     * @param {*} string
     * @returns {*} date
     */
    getISODate(locale) {
        if (locale) {
            let arr = locale.substring(this.dateStartIndex,this.dateEndIndex).split('.');
            return new Date(`${arr[2]}-${arr[1]}-${arr[0]}T00:00:00`);
        }
        return '';
    }
}